export default __webpack_public_path__ + "images/chevron-up.svg?28c0d782013b5385355f38a023fef3a8";